import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function RiskSubmerchants() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])
    const [reload, setReload] = useState(false)

    // ▼ 탭 상태 (가맹점 수정 / 정산주기 / PG정보)
    const [activeTab, setActiveTab] = useState("갱신예정")
    const [listState, setListState] = useState(false)

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 검색구분 포맷
    const select4 = ["가맹점명", "가맹점아이디"]

    const [selectedValue3, setSelectedValue3] = useState("가맹점명");
    const [selectedText3, setSelectText3] = useState("")

    const handleSelectChange3 = (event) => {
        const value = event.target.value;
        setSelectedValue3(value);
    };

    const handleSelectTextChange3 = (event) => {
        const value = event.target.value;
        setSelectText3(value);
    };

    // 검색 버튼
    const submit = () => {
        setReload(e => !e)
    }

    useEffect(() => {
        dispatch(change_Current_Location("가맹점갱신관리"))
        dispatch(changeHeaderTitle({
            mainTitle: "가맹점갱신관리"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    useEffect(() => {
        ListData()
    }, [page, reload])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/rm/merchant-renewal-warnings", {
            withCredentials: true,
            params: {
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.renewal_warnings ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.renewal_warnings ?? []]);
                }
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            // navigate("/");
        });
    }

    const onSubmit = async (data) => {
        if (window.confirm("상태값을 변경하시겠습니까?")) {
            await axios.post(
                process.env.REACT_APP_API + "/api/rm/merchant-review-complete",
                {
                    mid: data.mid,
                    review_result: "COMPLETED",
                    review_memo: "갱신확인",
                },
                {
                    withCredentials: true,
                }
            )
                .then((response) => {
                    let tmp = response?.data;
                    console.log(tmp)
                    if (tmp?.code < 2000) {
                        setPage(1)
                        setReload((e) => !e);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const tableHeaderData =
        [
            { "no": 1, "text": "갱신상태", "width": "100px", "textAlign": "center" },
            { "no": 2, "text": "가맹점명", "width": "200px", "textAlign": "center" },
            { "no": 3, "text": "최근 갱신 날짜", "width": "140px", "textAlign": "center" },
            { "no": 3, "text": "상태", "width": "80px", "textAlign": "center" },
        ]

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            setCombineList(listTrxData)

            for (let i = 0; i < listTrxData.length; i++) {
                let data = listTrxData[i]

                let rowData = [
                    {
                        "no": 2, "text": (
                            data.warning_level == "CRITICAL"
                                ? <span style={{color:"red", fontWeight:"bold"}}>갱신기간 지남</span>
                                : <span style={{color:"orange", fontWeight:"bold"}}>갱신 임박</span>
                        ), "width": "100px", "textAlign": "center"
                    },
                    { "no": 2, "text": data.co_nm, "width": "200px", "textAlign": "left" },
                    { "no": 3, "text": data.reg_dt, "width": "140px", "textAlign": "center" },
                    {
                        "no": 3, "text": (
                            <div
                                className="flex justify-center items-center"
                                style={{ gap: "15px" }}
                            >
                                <a
                                    className="delete flex items-center text-success pointer"
                                    onClick={() => onSubmit(data)}
                                >
                                    <SquareCheck width={15} height={15} /> 갱신
                                </a>
                            </div>
                        ), "width": "80px", "textAlign": "center"
                    },
                ]

                rowData.id = data.id
                tableBodyData.push(rowData);
            }
            setListState(e => !e)
            setCombineData(tableBodyData)
        }
    }, [listTrxData, page, maxFirstPage, reload
        // selectedValue3, selectedText3,
    ])

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                    {/* {<SearchSelectText type={"검색구분"} selectData={select4} handleSelectChange={handleSelectChange3} selectedValue={selectedValue3} handleSelectTextChange={handleSelectTextChange3} selectedText={selectedText3} btnText={"검색"} onClick={() => submit()} />} */}

                </form>
            </div>
            <div className="intro-y box intro-padding" >
                <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                    <div style={{ width: "100%", maxWidth: "530px" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.totCnt ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"820px"}
                            spinner={spinner}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RiskSubmerchants